import { ADD_KEYBOARD_EVENTS, DEL_KEYBOARD_EVENTS } from '../types';

export const subscribeKeyboard = () => (dispatch) => {
  dispatch({ type: ADD_KEYBOARD_EVENTS });
}

export const unsubscribeKeyboard = () => (dispatch) => {
  dispatch({ type: DEL_KEYBOARD_EVENTS });
}
